import React from 'react';
import { PageHero } from '../components/PageHero';
import { LocationCard } from '../components/LocationCard';
import { LOCATIONS } from '../data/locations';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a48b4252-372c-4a0d-a014-aacfbcc2a091.jpg';
export function Locations() {
  return <main className="w-full bg-black" data-id="element-318" data-mp="27kqi6iic0c6f">
      <PageHero image={HERO_IMAGE} eyebrow="Nine Studios" title="Our Locations" subtitle="Find a Me Time studio near you. The same unhurried experience at every venue." note="Relaxing Asian-style massage inspired by traditional techniques from across East and Southeast Asia." data-id="element-319" data-mp="27hku96lfvgca" />
      <section aria-label="All locations" className="glow-warm w-full bg-black" data-id="element-320" data-mp="1otfra1clvzej">
        <div className="mx-auto grid w-full max-w-7xl gap-6 px-5 py-24 sm:px-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-321" data-mp="1orcriplnirwm">
          {LOCATIONS.map((location, i) => <LocationCard key={location.slug} location={location} index={i} data-id="element-322" data-mp="w3qr1q7q03dz" data-mpi={i} />)}
        </div>
      </section>
    </main>;
}